import {IconName} from '@lightricks/react-design-system';
import {FeatureName} from '@contentlab/types/project';

function getFeatureIconName(featureName: FeatureName): IconName {
  switch (featureName) {
    case FeatureName.REFORMATTING:
      return 'Features-Scale';
    case FeatureName.AI_DUBBING:
      return 'Features-Dub';
    case FeatureName.REPHRASING:
      return 'Features-Rescript';
    case FeatureName.CAPTIONS:
      return 'Features-Captions';
    case FeatureName.AI_AVATAR:
      return 'Features-Avatar';
    case FeatureName.UPSCALE:
      return 'Features-Upscale';
    default:
      console.error(`${featureName} does not have a corresponding icon.`);
      return 'Navigation-Question-Line';
  }
}

export default getFeatureIconName;
